<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $t('messages.absenteeism'),
                        href: meta.links.absenteeism_index,
                    },
                    {
                        name: $t('messages.month'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.index" method="GET" @submit.prevent="filter">
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 md:grid-cols-12">
                <div class="sm:col-span-4">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.month')" for="month" />
                        <FormSelect
                            required
                            id="month"
                            v-model="form.month"
                            :options="options.months"
                            class="mt-1 w-full"
                            :null-option="false"
                        />
                        <FormError :value="form.errors.month" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <label class="block text-sm font-medium leading-5 text-gray-700"> &nbsp; </label>
                    <div class="mt-2">
                        <SubmitFormButton
                            :button-text="$t('messages.filter')"
                            :processing="form.processing"
                            is-filter
                        />
                    </div>
                </div>
            </div>
        </form>
        <div v-if="table.groups.length === 0" class="flex flex-col mt-5">
            <EmptyState picture />
        </div>
        <div class="flex flex-col mt-5" v-else>
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs px-2 py-1 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.group') }}
                                </th>
                                <th
                                    class="max-w-xs px-2 py-1 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    v-for="header in table.headers"
                                    :key="header.key"
                                    :title="header.title"
                                >
                                    {{ header.key }}
                                </th>
                                <th
                                    class="max-w-xs px-2 py-1 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $tc('messages.students', 2) }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(group, index) in table.groups" :key="group.id">
                                <tr :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'">
                                    <td class="px-2 py-1 whitespace-nowrap text-sm leading-5 text-gray-500">
                                        {{ group.name }}
                                    </td>
                                    <td
                                        class="px-2 py-1 whitespace-nowrap text-sm leading-5 text-gray-500"
                                        v-for="range in group.ranges"
                                    >
                                        {{ range.count }}
                                    </td>
                                    <td class="px-2 py-1 whitespace-nowrap text-sm leading-5 text-gray-500">
                                        {{ group.count }}
                                    </td>
                                </tr>
                                <tr :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'">
                                    <td class="px-2 py-1 whitespace-nowrap text-sm leading-5 text-gray-500">-</td>
                                    <td
                                        class="px-2 py-1 whitespace-nowrap text-sm leading-5 text-gray-500"
                                        v-for="range in group.ranges"
                                    >
                                        {{ range.percent }}%
                                    </td>
                                    <td class="px-2 py-1 whitespace-nowrap text-sm leading-5 text-gray-500">-</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="mt-5" v-if="table.groups.length">
            <apexchart
                :type="table.graph.chart.type"
                :height="table.graph.chart.height"
                :series="table.graph.series"
                :options="table.graph"
            >
            </apexchart>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import EmptyState from '@/components/EmptyState.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        PanelPage,
        FormSelect,
        FormLabel,
        FormError,
        EmptyState,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'filters', 'options', 'table'],
    data() {
        return {
            form: this.$inertia.form({
                month: this.filters.month,
            }),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
